import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";

import {getNumberFormat, objectToQueryString, pushUrl} from "../../../../utils/functions"
import Dropdown from "../../../etc/dropdown";

import {JOURNAL_ORDER_BY_OPTIONS, ORDER, BASE_PATH} from "../../../../wpconfig/index";
import * as func from "../../../../utils/functions";

class JournalOrder extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOrderDisable: false
		}
	}

	paramEvnet = (name, value) => {
		if (name === 'order_by' && value === 'scoring') {
			this.setState({isOrderDisable: true})
		} else {
			this.setState({isOrderDisable: false})
		}
		const {dataActions} = this.props;
		let param = this.props.param;
		param[name] = value;
		dataActions.setJournals({"param": param});

		func.getData("journals", this.props.param).then((response) => {
			dataActions.setJournals(response);
			const url = objectToQueryString(this.props.param);
			pushUrl('검색', BASE_PATH + 'journals/?' + url, this.props.param);
			// pushUrl('검색', BASE_PATH + 'journals/', null);
		});
	}

	render() {
		return (
			<>
				<div className="d-flex align-items-center">
					<h3 className="con-title">검색결과 ({this.props.totalRecords ? getNumberFormat(this.props.totalRecords) : 0})</h3>
				</div>
				<div className="d-flex align-items-center">
					<div className="d-flex mulity-dropdown">
						<Dropdown options={JOURNAL_ORDER_BY_OPTIONS} value={this.props.param.order_by} onChange={this.paramEvnet}
						          name="order_by"/>
						<Dropdown options={ORDER} value={this.props.param.order} onChange={this.paramEvnet} name="order"
						          isDisable={this.state.isOrderDisable}/>
					</div>
				</div>
			</>
		)
	}
}


export default connect(
	(state) => ({
		param: state.journals.param ? state.journals.param : {},
		totalRecords: state.journals.totalRecords ? state.journals.totalRecords : 0,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(JournalOrder)

JournalOrder.propTypes = {
	// args : PropTypes.object,
	// facet : PropTypes.object,
};
